import { render, staticRenderFns } from "./codeProp.vue?vue&type=template&id=fa71e1a8&scoped=true"
import script from "./codeProp.vue?vue&type=script&lang=js"
export * from "./codeProp.vue?vue&type=script&lang=js"
import style0 from "./codeProp.vue?vue&type=style&index=0&id=fa71e1a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa71e1a8",
  null
  
)

export default component.exports